//在此处编写调用授权等基本平台接口
class es_api {
	constructor(axiosFactory) {
		this.$http = axiosFactory;
	}
	http() {
		return this.$http;
	};
	  get(url, cb) {
		this.$http.get(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});;
	}
	gets(url, data, cb) {
		this.$http.get(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	post(url, data, cb) {
		this.$http.post(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	posts(url, cb) {
		this.$http.post(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	put(url, data, cb) {
		this.$http.put(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	puts(url, cb) {
		this.$http.put(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	delete(url, data, cb) {
		this.$http.delete(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	deletes(url, cb) {
		this.$http.delete(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	
	//------------------------------------------------------------
	// 验证提交的密码是否正确
	getCheckPassword(password,cb) {
		this.get(`/applicants/my/password/check?password=${password}`, cb);
	}
	//获取安全中心所有数据
	getInformations(cb) {
		this.get("/applicants/my/simple", cb);
	}
	//获取验证码
	getCode(data, cb) {
		this.post("applicants/my/mobile/verifies", data, cb);
	}
	//获取新手机验证码
	postVerifies(data, cb) {
		this.post('/verifies', data, cb)
	}
	//修改邮箱
	getEmail(data, cb) {
		this.put("/applicants/my/email", data, cb);
	}
	//修改密码
	getPassword(data, cb) {
		this.put("/applicants/my/password", data, cb);
	}
	//修改手机号码
	getPutChangeMobile(data, cb) {
		this.put("applicants/my/mobile", data, cb);
	}
	//[求职者]获取账号简要信息
	getInformations(cb) {
		this.get("/applicants/my/simple", cb);
	}

}
class apiFactory {
	constructor() {

	}
	createApi(axios) {
		return new es_api(axios)
	}
}
export default new apiFactory();
